import * as actionTypes from '../constants/actionTypes';
import _ from 'lodash';

const initialState = {
  featureInclusionData: [],
  featureSelection: {
    page: 0,
    selectedFeatureGroup: null,
    checkedFeatureGroups: [],
    checkedFeatures: [],
    searchTerm: null
  },
  featureList: [],
  page: 0,
  addPresetPopupShowing: false,
  addAssigneePopupShowing: false,
  selectedPreset: null,
  searchTerm: null,
  assign_page: 0,
  assign_term: null,
  customers: [],
  assign_checked: [],
  fabricatorInclusionPreset: null
};

function getFeatureGroupIndex(featureGroups, featureGroup) {
  return _.findIndex(featureGroups, (fg) => { return fg.name == featureGroup; });
}

function getIndexOfId(array, id) {
  return _.findIndex(array, (a) => { return a.id == id; });
}

function getFeatureListIndexByFeatureId(featureList, featureId) {
  for(let index = 0; index < featureList.length; index++) {
    let feature = featureList[index];
    for(let n = 0; n < feature.featureIds.length; n++) {
      if(featureId == feature.featureIds[n]) {
        return index;
      }
    }
  }
  return -1;
}

function getIndexOfFeatureListByFeatureIds(featureList, featureIds) {
  for(let index = 0; index < featureList.length; index++) {
    let feature = featureList[index];
    for(let n = 0; n < feature.featureIds.length; n++) {
      if(_.isEqual(feature.featureIds, featureIds)) {
        return index;
      }
    }
  }
  return -1;
}

const getFeatureInclusionPresetIndex = (state, id) => getIndexOfId(state.featureInclusionData, id);
const getFeatureIndex = (features, id) => getIndexOfId(features, id);
const getAssigneeIndex = (assignees, id) => getIndexOfId(assignees, id);

function sortByName(a, b) {
  if(a.name < b.name) {
    return -1;
  } else if(a.name > b.name) {
    return 1;
  }
  return 0;
}


export default function featureInclusionReducer(state = initialState, action) {
  let newState = null
    , fipIndex = -2
    , fgIndex  = -2;
  switch (action.type) {
    case actionTypes.FEATURE_INCLUSION_LOADED:
      newState = {...state};
      newState.featureInclusionData = action.payload.fabricatorPresetData;
      newState.featureInclusionData.sort(sortByName);
      newState.addAssigneePopupShowing = false;
      newState.featureList = action.payload.featureList;
      break;
    case actionTypes.FEATURE_INCLUSION_PRESET_CREATED:
      newState = {...state};
      newState.featureInclusionData = [...newState.featureInclusionData] || [];
      newState.featureInclusionData.unshift({
        id: action.payload.id,
        name: action.payload.name,
        description: action.payload.description
      });
      newState.selectedPreset = action.payload.id;
      break;
    case actionTypes.FEATURE_INCLUSION_PRESET_DELETED:
      newState = {...state};
      _.remove(newState.featureInclusionData, (val) => { return val.id == action.payload.featureInclusionPresetId; })
      newState.featureInclusionData = [...newState.featureInclusionData];
      break;
    case actionTypes.FEATURE_INCLUSION_PRESET_ENABLE_GROUP: 
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      fgIndex = getFeatureGroupIndex(newState.featureInclusionData[fipIndex].featureGroups, action.payload.featureGroup);

      if(fgIndex <= -1) {
        newState.featureInclusionData[fipIndex].featureGroups = [{
          name: action.payload.featureGroup,
          enabled: action.payload.enabled,
          overrideFeatureEnabled: action.payload.overrideFeatureEnabled
        }]
      } else {
        newState.featureInclusionData[fipIndex].featureGroups[fgIndex].enabled = action.payload.enabled;
        newState.featureInclusionData[fipIndex].featureGroups[fgIndex].overrideFeatureEnabled = action.payload.overrideFeatureEnabled;
      }
      break;
    case actionTypes.FEATURE_INCLUSION_FEATURE_ENABLE:
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      let ffIndex = getFeatureIndex(newState.featureInclusionData[fipIndex].features, action.payload.featureId);
      if(ffIndex <= -1) {
        newState.featureInclusionData[fipIndex].features = [{
          id: featureId,
          enabled: action.payload.enabled
        }];
      } else {
        newState.featureInclusionData[fipIndex].features[ffIndex].enabled = action.payload.enabled;
      }
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEE_ADDED:
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      let aaIndex = getAssigneeIndex(newState.featureInclusionData[fipIndex].assignees, action.payload.customerId);
      if(aaIndex <= -1) {
        newState.featureInclusionData[fipIndex].assignees.push(action.payload.customerId);
      }
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEE_REMOVED:
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      let arIndex = getAssigneeIndex(newState.featureInclusionData[fipIndex].assignees, action.payload.customerId);
      if(arIndex <= -1) {
        newState.featureInclusionData[fipIndex].assignees.splice(arIndex, 1);
      }
      break;
    case actionTypes.FEATURE_INCLUSION_SHOW_ADD_PRESET:
      newState = {...state};
      newState.addPresetPopupShowing = action.payload.show;
      break;
    case actionTypes.FEATURE_INCLUSION_SHOW_ADD_ASSIGNEE:
      newState = {...state};
      newState.addAssigneePopupShowing = action.payload.show;
      newState.assign_term = null;
      newState.assign_page = 0;
      break;
    case actionTypes.FEATURE_INCLUSION_PAGE_CHANGE:
      newState = {...state};
      newState.page = action.payload.page;
      break;
    case actionTypes.FEATURE_INCLUSION_SET_SELECTED_PRESET:
      newState = {...state};
      newState.selectedPreset = (((newState.selectedPreset == action.payload.selectedPreset) && !action.payload.setOnly) ? 0 : action.payload.selectedPreset);
      let selectedPreset = newState.featureInclusionData[getFeatureInclusionPresetIndex(newState, action.payload.selectedPreset)];
      let assignees = selectedPreset.assignees || [];
      let checked = [];
      for(let i = 0; i < assignees.length; i++) {
        let assignee = assignees[i];
        checked.push(assignee.id);
      }
      newState.assign_checked = checked;
      newState.featureSelection.checkedFeatureGroups = [];
      if(selectedPreset.featureGroups) {
        for(let i = 0; i < selectedPreset.featureGroups.length; i++) {
          newState.featureSelection.checkedFeatureGroups.push(selectedPreset.featureGroups[i].featureGroup);
        }
      }

      newState.featureSelection.checkedFeatures = [];
      if(selectedPreset.features) {
        for(let i = 0; i < selectedPreset.features.length; i++) {
          let feature = selectedPreset.features[i];
          let featureIndex = getFeatureListIndexByFeatureId(newState.featureList, feature.id);
          if(featureIndex >= 0) {
            if(getFeatureListIndexByFeatureId(newState.featureSelection.checkedFeatures, feature.id) == -1) {
              newState.featureSelection.checkedFeatures.push(newState.featureList[featureIndex]);
            }
          }
        }
      }
      newState.featureSelection.page = 0;

      break;
    case actionTypes.FEATURE_INCLUSION_SET_SEARCH_TERM:
      newState = {...state};
      newState.searchTerm = action.payload.searchTerm;
      newState.page = 0;
      break;
    case actionTypes.FEATURE_INCLUSION_VALUE_UPDATE:
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      newState.featureInclusionData[fipIndex][action.payload.key] = action.payload.value;
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEE_SET_CHECK:
      newState = {...state};
      let existingIndex = _.indexOf(newState.assign_checked, action.payload.customer_id);
      if(existingIndex >= 0) {
        newState.assign_checked.splice(existingIndex, 1);
      } else {
        newState.assign_checked.push(action.payload.customer_id);
      }
      newState.assign_checked = [...newState.assign_checked];
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEE_SET_PAGE:
      newState = {...state};
      newState.assign_page = action.payload.page;
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEE_SET_SEARCH_TERM:
      newState = {...state};
      newState.assign_term = action.payload.searchTerm;
      newState.assign_page = 0;
      break;
    case actionTypes.FEATURE_INCLUSION_CUSTOMERS_LOADED:
      newState = {...state};
      newState.customers = action.payload;
      break;
    case actionTypes.FEATURE_INCLUSION_ASSIGNEES_SAVED:
      newState = {...state};
      fipIndex = getFeatureInclusionPresetIndex(newState, action.payload.featureInclusionPresetId);
      newState.featureInclusionData[fipIndex].assignees = action.payload.assignees;
      newState.addAssigneePopupShowing = false;
      break;
    case actionTypes.FEATURE_INCLUSION_SELECTION_SELECT_FEATURE_GROUP:
      newState = {...state};
      newState.featureSelection.selectedFeatureGroup = action.payload.featureGroup;
      newState.featureSelection.page = 0;
      break;
    case actionTypes.FEATURE_INCLUSION_SELECTION_CHECK_FEATURE_GROUP:
      newState = {...state};
      fgIndex = _.findIndex(newState.featureSelection.checkedFeatureGroups, (fg => fg == action.payload.featureGroup));
      if(fgIndex >= 0) {
        newState.featureSelection.checkedFeatureGroups.splice(fgIndex, 1);
      } else {
        newState.featureSelection.checkedFeatureGroups.push(action.payload.featureGroup);
      }
      newState.featureSelection.checkedFeatureGroups = [...newState.featureSelection.checkedFeatureGroups];
      break;
    case actionTypes.FEATURE_INCLUSION_SELECTION_CHECK_FEATURE:
      newState = {...state};
      let fIndex = getIndexOfFeatureListByFeatureIds(newState.featureSelection.checkedFeatures, action.payload.feature.featureIds);
      if(fIndex >= 0) {
        newState.featureSelection.checkedFeatures.splice(fIndex, 1);
      } else {
        newState.featureSelection.checkedFeatures.push(action.payload.feature);
      }
      newState.featureSelection.checkedFeatures = [...newState.featureSelection.checkedFeatures];
      break;
    case actionTypes.FEATURE_INCLUSION_FABRICATOR_PRESET_LOADED:
      newState = {...state};
      newState.fabricatorInclusionPreset = action.payload.preset;
      break;
    case actionTypes.FEATURE_INCLUSION_SELECTION_SET_SEARCH_TERM:
      newState = {...state};
      newState.featureSelection.searchTerm = action.payload.term;
      newState.featureSelection.page = 0;
      break;
    case actionTypes.FEATURE_INCLUSION_SELECTION_PAGE_CHANGE:
      newState = {...state};
      newState.featureSelection.page = action.payload.page;
      break;
  }
  if(newState) {
    //console.log(action.type, JSON.parse(JSON.stringify(newState)));
    return newState;
  }
  return state;
}